/* @flow */
/* eslint-disable react/no-danger */

import * as React from 'react';

import type {LeadCardData} from 'nutshell-core/types';

import {Avatar} from '../avatar';
import {Card} from '../card';
import './lead-card-basic.module.css';

type Props = {
    openLinkInNewTab?: boolean,
    showRelatedEntities?: boolean,
} & LeadCardData;

export class LeadCardBasic extends React.PureComponent<Props> {
    render() {
        const {avatarUrl, leadName, assignee, relatedCompany, relatedPerson, value} = this.props;

        return (
            <Card hasBorder={true}>
                <div styleName='container'>
                    <header styleName='header'>
                        <div
                            styleName={
                                this.props.showRelatedEntities
                                    ? 'header-border-container'
                                    : 'header-container'
                            }
                        >
                            <div styleName='avatar'>
                                <Avatar type='leads' avatarUrl={avatarUrl} size={36} />
                            </div>
                            <div styleName='header-info'>
                                <a
                                    href={this.props.htmlUrl}
                                    styleName='top-row'
                                    target={this.props.openLinkInNewTab ? '_blank' : '_self'}
                                    rel={this.props.openLinkInNewTab ? 'noopener noreferrer' : ''}
                                >
                                    <span dangerouslySetInnerHTML={{__html: leadName}} />
                                </a>
                                <div styleName='bottom-row'>
                                    <span>{value}</span>
                                    <span styleName='spacer'>•</span>
                                    <span styleName='assignee'>
                                        {assignee ? assignee.name : 'Unassigned'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </header>
                    {this.props.showRelatedEntities ? (
                        <div styleName='body'>
                            <div styleName='related-entity-container'>
                                <div styleName='related-entity'>
                                    {relatedCompany ? (
                                        <a
                                            styleName='related-company'
                                            href={relatedCompany.htmlUrl}
                                            target={
                                                this.props.openLinkInNewTab ? '_blank' : '_self'
                                            }
                                            rel={
                                                this.props.openLinkInNewTab
                                                    ? 'noopener noreferrer'
                                                    : ''
                                            }
                                        >
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: relatedCompany.name,
                                                }}
                                            />
                                        </a>
                                    ) : (
                                        <i>No company added</i>
                                    )}
                                </div>
                                <div styleName='related-entity'>
                                    {relatedPerson ? (
                                        <a
                                            styleName='related-person'
                                            href={relatedPerson.htmlUrl}
                                            target={
                                                this.props.openLinkInNewTab ? '_blank' : '_self'
                                            }
                                            rel={
                                                this.props.openLinkInNewTab
                                                    ? 'noopener noreferrer'
                                                    : ''
                                            }
                                        >
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: relatedPerson.name,
                                                }}
                                            />
                                        </a>
                                    ) : (
                                        <i>No person added</i>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : undefined}
                </div>
            </Card>
        );
    }
}
